import React from "react";

function Errors({ errors: { status, msg } }) {
  const error =
    msg === "No direct availability on this date."
      ? "Sorry! It doesn't look like there's availability at the selected date, time, and party size. Please adjust and try again. If you feel this is an error, please let us know by contacting <a href='mailto:eat@thebatterysf.com'>eat@thebatterysf.com</a>. Cheers!"
      : msg;
  if (error) {
    return (
      <div>
        <p style={{ color: "red" }}>
          <span dangerouslySetInnerHTML={{ __html: error }} />
        </p>
      </div>
    );
  } else {
    return null;
  }
}

export default Errors;
